import { useTranslation } from 'react-i18next';

import { useGetAuthApi } from '@/hooks/UseApiCalls';
import type { FundLookupDtoIn } from '@/models/in/NedarimDecodeModels';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/Tabs/Tabs';
import ManualAssignmentTab from './ManualAssignmentTab';
import AutoClassifiedTab from './AutoClassifiedTab';
import DecodeRulesTab from './DecodeRulesTab';
import { FUNDS_LOOKUP_URL } from './nedarimTransactionsFundAllocation';
import styles from './NedarimTransactionsFundAllocationPage.module.scss';

/**
 * Fund classification for Nedarim transactions (SPR-1096). Most transactions are placed by the sync
 * automatically; this screen is where the office finishes the rest — assign what the rules could not
 * place, review and correct what they did place, and maintain the rules themselves.
 */
const NedarimTransactionsFundAllocationPage = () => {
  const { t } = useTranslation();

  // Loaded once here and shared with every tab's fund picker.
  const { data: funds } = useGetAuthApi<FundLookupDtoIn[]>(FUNDS_LOOKUP_URL);
  const fundList = funds ?? [];

  return (
    <div className={styles.page}>
      <h1 className="heading-h2-semibold">{t('nedarimTransactionsFundAllocation.title')}</h1>

      <Tabs defaultValue="manual" style={{ direction: 'rtl' }}>
        <TabsList>
          <TabsTrigger value="manual">{t('nedarimTransactionsFundAllocation.tabs.manualTab')}</TabsTrigger>
          <TabsTrigger value="auto">{t('nedarimTransactionsFundAllocation.tabs.autoTab')}</TabsTrigger>
          <TabsTrigger value="rules">{t('nedarimTransactionsFundAllocation.tabs.rulesTab')}</TabsTrigger>
        </TabsList>

        <TabsContent value="manual">
          <ManualAssignmentTab funds={fundList} />
        </TabsContent>
        <TabsContent value="auto">
          <AutoClassifiedTab funds={fundList} />
        </TabsContent>
        <TabsContent value="rules">
          <DecodeRulesTab funds={fundList} />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default NedarimTransactionsFundAllocationPage;
